import { Navigate } from 'react-router-dom';

export function protectedSignInUrl(returnUrl: string): string {
  const query = new URLSearchParams({
    sign_in_force_redirect_url: returnUrl,
    sign_up_force_redirect_url: returnUrl,
  });

  return `/sign-in?${query.toString()}`;
}

export function ProtectedSignInRedirect({ returnUrl }: { returnUrl: string }) {
  return <Navigate to={protectedSignInUrl(returnUrl)} replace />;
}
